// Abre submenús al pasar el mouse (solo desktop)
document.addEventListener('DOMContentLoaded', () => {
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  const menuDetails = document.querySelectorAll(
    '.header__inline-menu details, .header__menu details, header details'
  );

  menuDetails.forEach((details) => {
    const summary = details.querySelector('summary');
    if (!summary) return;

    let closeTimer;

    details.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    });

    details.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      closeTimer = setTimeout(() => {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, 80); // micro delay para que no parpadee
    });
  });
});
